// @tenorlab/nuxt-dashboard-pro
// file: app/models/app/AppMenuType.enum.ts
export const enum AppMenuTypeEnum {
  full = 1,
  evaluation = 2,
}
